import { purchaseStarted } from "@common/analytics";
import { PublicPurchaseServiceViewModel } from "@/viewmodels.g";
import { useRouter } from "vue-router";
import { COMMON_ROUTE_NAMES } from "@common/routing";

export default function usePurchase() {
  const purchaseService = new PublicPurchaseServiceViewModel();

  // Vue Router
  const router = useRouter();

  return {
    initiatePurchase: purchaseService.initiatePurchase,
    initiateSeriesPurchase: purchaseService.initiateSeriesPurchase,

    startPurchase: async (
      selectTicketsUrl: string | null,
      eventDateId: number | null,
      accessCode: string | null = null,
    ) => {
      // Open external URL if provided
      if (selectTicketsUrl) {
        window.open(selectTicketsUrl, "_blank");
        return;
      }

      const initiatePurchase = purchaseService.initiatePurchase;
      // Set args
      initiatePurchase.args.eventDateId = eventDateId;
      initiatePurchase.args.accessCode = accessCode;
      await initiatePurchase.invokeWithArgs();

      const newPurchase = initiatePurchase.result;
      if (newPurchase) {
        purchaseStarted(newPurchase);

        // Navigate to ticket purchase page
        router.push({
          name: COMMON_ROUTE_NAMES.TicketPurchaseSingle,
          params: { publicId: newPurchase.publicId! },
        });
      }
    },

    // Returns false when no purchase was created (e.g. access code required) so callers can fall back.
    startSeriesPurchase: async (
      eventSeriesId: number | null,
      accessCode: string | null = null,
    ): Promise<boolean> => {
      const caller = purchaseService.initiateSeriesPurchase;
      await caller(eventSeriesId, accessCode);

      const newPurchase = caller.result;
      if (!newPurchase) {
        return false;
      }
      purchaseStarted(newPurchase);
      router.push({
        name: COMMON_ROUTE_NAMES.TicketPurchaseSingle,
        params: { publicId: newPurchase.publicId! },
      });
      return true;
    },
  };
}
